import { countRangeWiseInfo } from "./product-count-wise-bom-info";

export class seriesInfo {
    data: countRangeWiseInfo[];
    id?: string;
    label?:string;
    /**
     * 
     * @param data
     */
    constructor(data: countRangeWiseInfo[],id?:string,label?:string) {
        this.data = data;
        this.id = id;
        this.label = label;
    }
}